import { IconConfig } from "../types";

export const UsersGroup:IconConfig = {
  type: 'fill' as const,
  viewBox: "0 -5 32 32",
  paths: [
    "M18.591 18.657v-1.281a6.92 6.92 0 0 0 3.1-5.757c0-3.85 0-6.971-4.648-6.971s-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.281c-5.255.43-9.3 3.012-9.3 6.134h21.691c0-3.122-4.04-5.7-9.3-6.134Zm-10.67.6a14.7 14.7 0 0 1 4.836-1.947 8.7 8.7 0 0 1-.98-1.429 8.9 8.9 0 0 1-1.125-4.258 13.8 13.8 0 0 1 .741-5.659 5.04 5.04 0 0 1 3.854-2.892c-.409-1.851-1.5-3.068-4.4-3.068-4.648 0-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.278c-5.255.43-9.3 3.012-9.3 6.134h6.755a10 10 0 0 1 1.167-.892Z"
  ]
} as const
